import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule, MetaReducer, ActionReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { localStorageSync } from 'ngrx-store-localstorage';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      { authenticationFeature: ['authToken', 'email', 'accountDetails'] },
      {
        CompanyConfigFeature: ['companyConfig', 'companyConfigIndex', 'isAnonymousBrowsing', 'siteId', 'orderFromSite'],
      },
      {
        CompanyGroupFeature: ['CompanyGroup'],
      },
      {
        CartFeature: ['cart', 'accountID', 'cartStartTime'],
      },
      {
        OrderFeature: [
          'orderID',
          'accountID',
          'periodId',
          'orderDetails',
          'orderLocation',
          'timeSlot',
          'deliveryLocation',
          'childDeliveryLocation',
          'table',
          'orderCompletedOn',
          'guestCheckoutOrderID',
          'customerInfo',
          'orderItems',
          'reOrderItems',
          'paymentSessionCreate',
          'paymentSessionIntent',
          'discountResponse',
        ],
      },
      {
        ChooseLocationFeature: ['selectedLocation', 'selectedTimeslot', 'locationPropTypes', 'acceptedAgeRestrictionYears'],
        reviver: (val) => {
          return val;
        },
      },
      {
        favouriteItemFeature: ['favoriteItems', 'limitsReached'],
      },
    ],
    rehydrate: true,
    restoreDates: false,
  })(reducer);
}

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot(
      {},
      {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
        initialState: {},
      }
    ),
    EffectsModule.forRoot([]),
    // todo: enable only in dev
    StoreDevtoolsModule.instrument(),
  ],
})
export class SharedCommonStateModule {}
